import { Table } from "@tiptap/extension-table";
import { columnResizing, tableEditing } from "@tiptap/pm/tables";

// Forced to do this cause by default if not editable at start tiptap is not loading the resizable plugin, and it doesn't work when toggling editable later.
//
// Lives in its own module (alongside ResizableImage.js / Video.js) so the table behaviour can be
// exercised in jsdom without pulling in the whole editor component — see tableResize.test.js.
const ResizableTable = Table.extend({
  addProseMirrorPlugins() {
    return [
      columnResizing({
        handleWidth: this.options.handleWidth,
        cellMinWidth: this.options.cellMinWidth,
        defaultCellMinWidth: this.options.cellMinWidth,
        View: this.options.View,
        lastColumnResizable: this.options.lastColumnResizable,
      }),
      tableEditing({
        allowTableNodeSelection: this.options.allowTableNodeSelection,
      }),
    ];
  },
});

export default ResizableTable;
